import { IconProps } from "../../types/genereal";
import { IconWrapper } from "../ui/IconWrapper";

export const OopsIcon = ({}: IconProps) => {
  return (
    <IconWrapper width={"100"} height={"81"}>
      <svg
        width="100"
        height="81"
        viewBox="0 0 100 81"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <ellipse
          cx="49.3001"
          cy="62.3263"
          rx="45.5814"
          ry="17.9845"
          fill="#ECEEF0"
        />
        <g clipPath="url(#clip0_12391_149743)">
          <path
            d="M46.7689 51.6267H52.4537V57.3114H46.7689V51.6267ZM46.7689 28.8877H52.4537V45.9419H46.7689V28.8877ZM49.6113 14.6758C33.8929 14.6758 21.1875 27.4665 21.1875 43.0996C21.1875 50.638 24.1821 57.8677 29.5126 63.1982C32.152 65.8376 35.2854 67.9313 38.734 69.3597C42.1825 70.7881 45.8786 71.5233 49.6113 71.5233C57.1497 71.5233 64.3794 68.5287 69.7099 63.1982C75.0404 57.8677 78.035 50.638 78.035 43.0996C78.035 39.3669 77.2998 35.6708 75.8714 32.2222C74.443 28.7737 72.3493 25.6403 69.7099 23.0009C67.0705 20.3615 63.9371 18.2678 60.4886 16.8394C57.0401 15.411 53.3439 14.6758 49.6113 14.6758ZM49.6113 65.8386C43.5805 65.8386 37.7968 63.4429 33.5324 59.1785C29.268 54.9141 26.8723 49.1303 26.8723 43.0996C26.8723 37.0688 29.268 31.285 33.5324 27.0206C37.7968 22.7562 43.5805 20.3605 49.6113 20.3605C55.642 20.3605 61.4258 22.7562 65.6902 27.0206C69.9546 31.285 72.3503 37.0688 72.3503 43.0996C72.3503 49.1303 69.9546 54.9141 65.6902 59.1785C61.4258 63.4429 55.642 65.8386 49.6113 65.8386Z"
            fill="#1F2932"
          />
          <circle cx="78.1361" cy="14.8841" r="5.5814" fill="#99A7BD" />
        </g>
        <line
          x1="3.71875"
          y1="32.2484"
          x2="11.1606"
          y2="32.2484"
          stroke="#99A7BD"
          strokeWidth="3.10078"
        />
        <circle cx="64.8015" cy="3.7214" r="3.41085" fill="#99A7BD" />
        <circle cx="13.9469" cy="41.5505" r="2.7907" fill="#99A7BD" />
        <defs>
          <rect
            width="68.2171"
            height="68.2171"
            fill="white"
            transform="translate(15.5 8.99219)"
          />
        </defs>
      </svg>
    </IconWrapper>
  );
};
